import { push } from 'connected-react-router';
import { safeDispatchPush } from '../../reducers/util';

export const viewCompanyAddress = companyId => dispatch =>
    safeDispatchPush(dispatch, push, ['company', 'address', companyId]);
